import { render, staticRenderFns } from "./ComplaintManage.vue?vue&type=template&id=46b6e411&scoped=true&"
import script from "./ComplaintManage.vue?vue&type=script&lang=js&"
export * from "./ComplaintManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b6e411",
  null
  
)

export default component.exports